import _classCallCheck from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.from.js";
/* eslint-disable no-underscore-dangle */
// Each of the sets added needs to be unique
var LazySet = /*#__PURE__*/function () {
  function LazySet() {
    var startingSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
    var assumeSetsAreDisjoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    _classCallCheck(this, LazySet);
    // Begins with a starting set which works as an "inner set"
    // where addition operations are performed
    this.sets = [startingSet];

    // If true, the set will assume any added sets don't share any values
    // This is useful for performance reasons
    // If set to false, the "size" operation will be fairly slow the first time it's called
    this.assumeSetsAreDisjoint = assumeSetsAreDisjoint;
    this._size = null;
  }
  _createClass(LazySet, [{
    key: "has",
    value: function has(value) {
      return this.sets.some(function (set) {
        return set.has(value);
      });
    }
  }, {
    key: "addSet",
    value: function addSet(set, assumeNewSetIsDisjoint) {
      if (assumeNewSetIsDisjoint === undefined) {
        // This is a reliability measure to make sure we
        // don't begin using LazySet in ways that will break it
        //
        // You can use sets that share items no problem, but that will mean that calculating the size
        // won't be supported for the reasons explained in its getter's error message
        throw new Error('You need to explicitly aknowledge you know that the sets are disjoint or that they aren\'t');
      }
      this.assumeSetsAreDisjoint = this.assumeSetsAreDisjoint && assumeNewSetIsDisjoint;
      this.sets.push(set);
    }
  }, {
    key: "add",
    value: function add(value) {
      this.sets[0].add(value);
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      if (this.modifiesExternalSets) {
        this.sets[0].forEach(function (set) {
          return set.delete(value);
        });
      } else {
        throw new Error('Attempt to modify external sets in LazySet');
      }
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "clear",
    value: function clear() {
      throw new Error('This is a lazy set, it cannot be cleared');
    }
  }, {
    key: "forEach",
    value: function forEach(callback) {
      this.sets.forEach(function (set) {
        set.forEach(function (item) {
          return callback(item);
        });
      });
    }

    // This allows us to use operators like `...` and `for of`
  }, {
    key: Symbol.iterator,
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function value() {
      var _iterator, _step, set;
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // eslint-disable-next-line no-restricted-syntax, no-unused-vars
            _iterator = _createForOfIteratorHelper(this.sets);
            _context.prev = 1;
            _iterator.s();
          case 3:
            if ((_step = _iterator.n()).done) {
              _context.next = 8;
              break;
            }
            set = _step.value;
            return _context.delegateYield(set, "t0", 6);
          case 6:
            _context.next = 3;
            break;
          case 8:
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t1 = _context["catch"](1);
            _iterator.e(_context.t1);
          case 13:
            _context.prev = 13;
            _iterator.f();
            return _context.finish(13);
          case 16:
          case "end":
            return _context.stop();
        }
      }, value, this, [[1, 10, 13, 16]]);
    }) // The only cell class that can have intersecting sets (not disjoint) is
    // scratchpad, which is not going to have more than one set in this.sets
    // so that case is safe
  }, {
    key: "size",
    get: function get() {
      if (!this.assumeSetsAreDisjoint && this.sets.length > 1) {
        throw new Error("Size operation is not supported when inner sets are not disjoint and more than one\nbecause it is very expensive and to discourage introducing performance issues unknowingly.\nInstead of using size, create a Set from the LazySet and use the size property of the Set\n");
      }
      if (this._size === null) {
        this._size = this.sets.reduce(function (acc, set) {
          return acc + set.size;
        }, 0);
      }
      return this._size;
    }

    // These were recently added and we haven't used them, so I am skipping on implementing them
    //
    // However, they can be easily implemented if you want
    // If you need one that is already implemented, make sure that it s correct before uncommenting it
    // About union, difference, etc. They could be implemented to return Sets or LazySets,
    // I didn't know what would be better so that's why I left them like this
    //
    // isDisjointFrom(otherSet) {
    //   return !this.some((value) => otherSet.has(value));
    // }
    //
    // difference(otherSet) {
    // }
    //
    // entries() {
    // }
    //
    // intersection(otherSet) {
    // }
    //
    // isSubsetOf(otherSet) {
    //   return this.every((value) => otherSet.has(value));
    // }
    //
    // isSupersetOf(otherSet) {
    //   return otherSet.every((value) => this.has(value));
    // }
    //
    // keys() {
    //   return this.values();
    // }
    //
    // symmetricDifference(otherSet) {
    //   const result = new Set(this);
    //   otherSet.forEach((value) => {
    //     if (result.has(value)) {
    //       result.delete(value);
    //     } else {
    //       result.add(value);
    //     }
    //   });
    //   return result;
    // }
    //
    // union(otherSet) {
    //   return new Set([...this, ...otherSet]);
    // }
    //
    // values() {
    //   return [...this];
    // }
  }]);
  return LazySet;
}();
export default LazySet;